<template>
    <div class="confirmation animated fadeIn">
        <div class="app" v-if="isLoading">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <data-loading class="my-5" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col></b-col>
                    <b-col>
                        <b-alert show variant="primary" class="text-center font-weight-bold small m-3">Идет обработка запроса...</b-alert>
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-container>
        </div>
        <div class="app">
            <b-row align-v="center" align-h="center">
                <b-col cols="9" class="mt-5">
                    <router-view @dataLoaded="isLoading = false;"></router-view>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'

    export default {
        name: 'confirmation',

        data () {
            return {
                isLoading: true
            }
        },

        components: {
            'data-loading': DataLoading
        }
    }
</script>

<style scoped="confirmation" lang="scss">
    div.confirmation {
        background: url(../assets/img/slides/2.jpg) center no-repeat;
        background-size: cover;
    }
</style>


// WEBPACK FOOTER //
// Confirmation.vue?28b65ce5